import styled from "@emotion/styled";
import { useChurchStore } from "features/churches";
import { useMemo } from "react";
import { useTransactions } from "../api";
import { StatCard, TransactionsTable } from "../components";
import { useOverviewStore } from "../store";

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
`;

export const Overview = () => {
  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const {
    viewTotalAvailableBalance,
    viewTotalRevenue,
    viewTotalExpense,
    setViewTotalAvailableBalance,
    setViewTotalRevenue,
    setViewTotalExpense
  } = useOverviewStore();

  const { data: transactions } = useTransactions({
    churchId: selectedChurch?.id,
    page: 1,
    pageSize: 10,
    type: "all"
  });

  const totalAvailableBalance = useMemo(
    () => transactions?.totals?.net || 0,
    [transactions]
  );

  const totalRevenue = useMemo(
    () => transactions?.totals?.revenue || 0,
    [transactions]
  );

  const totalExpense = useMemo(
    () => transactions?.totals?.expense || 0,
    [transactions]
  );
  return (
    <>
      <StatGrid>
        <StatCard
          title="Total Available Balance"
          stat={totalAvailableBalance}
          isVisible={viewTotalAvailableBalance}
          toggleVisibility={() =>
            setViewTotalAvailableBalance(!viewTotalAvailableBalance)
          }
        />
        <StatCard
          title="Total Revenue"
          stat={totalRevenue}
          isVisible={viewTotalRevenue}
          toggleVisibility={() => setViewTotalRevenue(!viewTotalRevenue)}
        />
        <StatCard
          title="Total Expense"
          stat={totalExpense}
          isVisible={viewTotalExpense}
          toggleVisibility={() => setViewTotalExpense(!viewTotalExpense)}
        />
      </StatGrid>
      <TransactionsTable />
    </>
  );
};
